import $ from "jquery";

export const init = () => {
  // Veranstaltungskalender -------------------------------------------------------
  let $eventcalendar = $(".listtype-sfeventmgt_pieventlist");

  if ($eventcalendar.attr("id") !== undefined) {
    let ecId = $eventcalendar.attr("id").replace("c", "");

    let $ecPagination = $eventcalendar.find(".pagination");
    if ($ecPagination && $ecPagination.length > 0) {
      let ecNext = $ecPagination.find("li.next a");

      // Hide pagination
      $ecPagination.hide();

      // Check if there is a next link in pagination
      if (ecNext.length > 0) {
        // Ajax method to load more events, href is more linke href and obj is the more link object
        async function moreEvents(href, obj) {
          let data = await fetch(href)
            .then((response) => {
              return response.text();
            })
            .catch((error) => console.error(error));

          let eventList = $(data).find(".event-list").children();
          $eventcalendar.find("ul.event-list").append(eventList);

          // Change more link
          obj.off();
          let moreLink = $(data).find(".pagination li.next a");

          if (moreLink.length) {
            obj.on("click", function () {
              moreEvents(moreLink.attr("data-ajax"), obj);
            });
          } else {
            obj.hide();
          }

          return false;
        }

        // Create a new more link and append to content
        let moreLink = $("<a>", {
          text: "Weitere Veranstaltungen laden",
          class: "ajax-more btn secondary",
          title: "Mehr",
          href: "javascript:void(0);",
          click: function () {
            moreEvents(ecNext.attr("data-ajax"), $(this));
          },
        });
        $ecPagination.parent().append(moreLink);
      }
    }
  }
};
